<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-quality-high</v-icon>{{$t('profile.quality.focus')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <QualityFocusForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import QualityFocusForm from '../../components/qualityfocus/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'QualityFocus';

const { mapFields } = createHelpers({
  getterType: 'qualityfocus/getField',
  mutationType: 'qualityfocus/updateField'
});

export default {
  name: 'QualityFocusCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    QualityFocusForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('qualityfocus', ['create', 'reset'])
  }
};
</script>
